// extracted by mini-css-extract-plugin
export default {"container":"SavedPage_container__J+Xd8"};